<template>
    <div class="default-graph">
        <div class=""
            :class="`default-graph-img default-graph-img${type}`"
        ></div>

        <div v-if="text" class="default-graph-text">{{ text }}</div>
    </div>
</template>

<script>
export default {
  name: 'defaultGraph',
  props: {
    type: {
      type: String,
      default: '1'
    },
    text: {
      type: String,
      default: ''
    },
  },
};
</script>

<style lang="scss" scoped>
.default-graph {
    position: relative;
    width: 100%;

    .default-graph-img {
        display: block;
        width: 200px;
        height: 200px;
        margin: 0 auto;

        // 404
        &.default-graph-img1 {
            background: url('~@/assets/images/web/default-page1.png') no-repeat center center / 100% 100%;
        }
        // 暂无内容
        &.default-graph-img2 {
            background: url('~@/assets/images/web/default-page2.png') no-repeat center center / 100% 100%;
        }
        // 审核中…
        &.default-graph-img3 {
            background: url('~@/assets/images/web/default-page3.png') no-repeat center center / 100% 100%;
        }
        // 网络超时
        &.default-graph-img4 {
            background: url('~@/assets/images/web/default-page4.png') no-repeat center center / 100% 100%;
        }
        // 暂无权限
        &.default-graph-img5 {
            background: url('~@/assets/images/web/default-page5.png') no-repeat center center / 100% 100%;
        }
        // 系统更新
        &.default-graph-img6 {
            background: url('~@/assets/images/web/default-page6.png') no-repeat center center / 100% 100%;
        }
        // 系统维护
        &.default-graph-img7 {
            background: url('~@/assets/images/web/default-page7.png') no-repeat center center / 100% 100%;
        }
        // 暂无搜索结果
        &.default-graph-img8 {
            background: url('~@/assets/images/web/default-page8.png') no-repeat center center / 100% 100%;
        }
        // 暂无消息
        &.default-graph-img9 {
            background: url('~@/assets/images/web/default-page9.png') no-repeat center center / 100% 100%;
        }
    }

    .default-graph-text {
        text-align: center;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: $color-text;
        line-height: 20px;
    }
}
</style>
